export const legacyTmExcelOffices = [
  { id: 'mock-office-1', name: 'Mock 지점' },
  { id: 'mock-office-2', name: 'Mock 테스트 지점' },
]

export const legacyTmExcelCodes = {
  category: ['Mock 신규상담', 'Mock 재상담'],
  feedback: ['Mock 통화완료', 'Mock 재연락'],
  status: ['Mock 진행', 'Mock 완료'],
}

export const legacyTmExcelHistory: Array<{
  no: number
  uploadedAt: string
  staff: string
}> = []

export const legacyTmExcelDetailHeaders = [
  'No', '*TM일자', '*TM종류', '*TM종류 코드', '고객명', '*(old)고객번호', '*고객번호', '*고객매칭',
  'TM담당자', 'TM담당자 ID', '*TM상태', '*TM상태 코드', '피드백 명', '피드백 코드', 'TM메모',
]
